<!-- Section Header -->
<p class="section-label">Rewards Points:</p>

<!-- Balance Display -->
<div class="balance-display">
  <ion-icon name="star" color="warning"></ion-icon>
  <span class="balance-amount">{{ balance }}</span>
  <span class="balance-label">points</span>
</div>

<!-- Manual Adjustment Form -->
<div class="adjustment-form">
  <p class="form-label">Manual Adjustment:</p>

  <div class="form-row">
    <ion-item class="form-item">
      <ion-label position="stacked">Amount (points)</ion-label>
      <ion-input
        type="number"
        min="1"
        placeholder="Enter amount"
        [(ngModel)]="adjustmentAmount"
      [disabled]="isSubmitting"></ion-input>
    </ion-item>
  </div>

  <div class="form-row">
    <ion-item class="form-item">
      <ion-label position="stacked">Description</ion-label>
      <ion-textarea
        rows="3"
        maxlength="500"
        placeholder="Enter reason for adjustment"
        [(ngModel)]="adjustmentDescription"
      [disabled]="isSubmitting"></ion-textarea>
    </ion-item>
  </div>

  <div class="form-actions">
    <ion-button
      color="success"
      [disabled]="isSubmitting"
      (click)="addPoints()">
      <ion-icon slot="start" name="add-circle"></ion-icon>
      Add Points
    </ion-button>

    <ion-button
      color="danger"
      [disabled]="isSubmitting"
      (click)="subtractPoints()">
      <ion-icon slot="start" name="remove-circle"></ion-icon>
      Subtract Points
    </ion-button>
  </div>
</div>

<!-- View Transaction History Button -->
<ion-button
  fill="outline"
  color="primary"
  (click)="openTransactionModal()">
  <ion-icon slot="start" name="receipt-outline"></ion-icon>
  View Transaction History
</ion-button>

<!-- Transaction History Modal -->
<ion-modal #transactionModal class="transaction-modal">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Transaction History</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="closeTransactionModal()">
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      @if (userId) {
        <rc-transaction-table [userId]="userId" [maxTransactions]="10"></rc-transaction-table>
      }
    </ion-content>
  </ng-template>
</ion-modal>
